<template>
  <div id="productPage">
    <!-- 页面头部 -->
    <div class="page-header">
      <h1>服务</h1>
      <p>我们提供一系列优质的服务，满足您的多样化需求。</p>
    </div>

    <!-- 服务卡片展示 -->
    <div class="product-cards">
      <el-card class="product-card" shadow="hover">
        <template #header>
          <div class="card-header">
            <i class="el-icon-product"></i>
            <h2>服务一</h2>
          </div>
        </template>
        <img src="@/assets/logo.jpg" alt="服务一" width="128" height="128" />
        <p>
          这是我们的第一项服务，它具有高效、稳定的特点，能够为您节省大量的时间和精力。
        </p>
        <el-button type="primary">了解更多</el-button>
      </el-card>
      <el-card class="product-card" shadow="hover">
        <template #header>
          <div class="card-header">
            <i class="el-icon-product"></i>
            <h2>服务二</h2>
          </div>
        </template>
        <img src="@/assets/logo.jpg" alt="服务一" width="128" height="128" />
        <p>第二项服务专注于提供个性化的解决方案，根据您的具体需求进行定制。</p>
        <el-button type="primary">了解更多</el-button>
      </el-card>
      <el-card class="product-card" shadow="hover">
        <template #header>
          <div class="card-header">
            <i class="el-icon-product"></i>
            <h2>服务三</h2>
          </div>
        </template>
        <img src="@/assets/logo.jpg" alt="服务一" width="128" height="128" />
        <p>我们的第三项服务采用了先进的技术，为您提供安全、可靠的保障。</p>
        <el-button type="primary">了解更多</el-button>
      </el-card>
    </div>
    <!-- 新增服务板块 - 图文列表形式 -->
    <div class="product-list">
      <h2 class="list-title">更多优质服务</h2>
      <ul>
        <li>
          <img src="https://via.placeholder.com/100" alt="Product 4" />
          <div class="product-info">
            <h3>服务四：数据智能分析</h3>
            <p>
              借助先进的算法和大数据技术，对您的业务数据进行深度挖掘和分析，为您提供精准的决策依据。无论是市场趋势预测、用户行为分析还是运营效率评估，我们的服务都能帮助您洞察数据背后的价值。
            </p>
            <el-button type="info">详细了解</el-button>
          </div>
        </li>
        <li>
          <img src="https://via.placeholder.com/100" alt="Product 5" />
          <div class="product-info">
            <h3>服务五：云端存储与管理</h3>
            <p>
              提供安全可靠的云端存储解决方案，让您无需担心数据丢失和存储容量问题。我们的云端平台支持多设备同步、数据备份和恢复，确保您的数据随时随地可访问和管理。
            </p>
            <el-button type="info">详细了解</el-button>
          </div>
        </li>
        <li>
          <img src="https://via.placeholder.com/100" alt="Product 6" />
          <div class="product-info">
            <h3>服务六：智能客服系统</h3>
            <p>
              采用人工智能和自然语言处理技术，打造高效智能的客服系统。能够实时响应客户咨询，自动解答常见问题，提高客户满意度和服务效率。同时，支持与人工客服无缝对接，为客户提供全方位的服务体验。
            </p>
            <el-button type="info">详细了解</el-button>
          </div>
        </li>
      </ul>
    </div>

    <!-- 新增服务板块 - 步骤流程形式 -->
    <div class="product-process">
      <h2 class="process-title">一站式培训服务流程</h2>
      <div class="steps">
        <el-steps
          :active="activeIndex"
          finish-status="finish"
          process-status="process"
          align-center
        >
          <el-step
            title="需求沟通"
            description="与您深入沟通需求，了解您的基础和期望。"
          ></el-step>
          <el-step
            title="方案设计"
            description="根据需求制定适合您的方案，提供多种可选方案供您选择。"
          ></el-step>
          <el-step
            title="初步尝试"
            description="为您提供免费的试听课。"
          ></el-step>
          <el-step title="确定报名" description="报名后即可上课。"></el-step>
          <el-step
            title="正式培训"
            description="根据您的基础为您1对1进行培训。"
          ></el-step>
          <el-step
            title="售后支持"
            description="提供长期的售后支持和答疑服务，保障您的满意。"
          ></el-step>
        </el-steps>
      </div>
      <el-button type="primary">去报名</el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const activeIndex = ref(0);
setInterval(() => {
  activeIndex.value = (activeIndex.value + 1) % 6;
}, 800);
</script>

<style lang="scss" scoped>
#productPage {
  background-color: #fff;
  padding: 40px;
  text-align: center;

  .page-header {
    margin-bottom: 40px;

    h1 {
      font-size: 36px;
      color: #0098db;
    }

    p {
      font-size: 18px;
      color: #666;
    }
  }

  .product-cards {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
    margin-bottom: 40px;
  }

  .product-card {
    width: 300px;
    border: none;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
    }

    .card-header {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      i {
        font-size: 24px;
        color: #409eff;
        margin-right: 10px;
      }

      h2 {
        font-size: 24px;
        color: #0098db;
      }
    }

    p {
      font-size: 16px;
      color: #666;
      margin-bottom: 20px;
    }

    .el-button {
      background-color: #409eff;
      border: none;
    }
  }

  .product-list {
    margin-bottom: 40px;

    .list-title {
      font-size: 28px;
      color: #0098db;
      margin-bottom: 20px;
    }

    ul {
      list-style: none;
      padding: 0;
      cursor: pointer;

      li {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 20px;
        border: 1px solid #eee;
        border-radius: 8px;
        padding: 20px;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          transform: translateY(-3px);
        }

        img {
          width: 100px;
          height: 100px;
          object-fit: cover;
          border-radius: 8px;
        }

        .product-info {
          text-align: left;

          h3 {
            font-size: 20px;
            color: #0098db;
            margin-bottom: 10px;
          }

          p {
            font-size: 16px;
            color: #666;
            margin-bottom: 10px;
          }

          .el-button {
            background-color: #409eff;
            border: none;
          }
        }
      }
    }
  }

  .product-process {
    .process-title {
      font-size: 28px;
      color: #0098db;
      margin-bottom: 20px;
    }

    .steps {
      margin-bottom: 20px;

      .el-button {
        background-color: #409eff;
        border: none;
      }
    }
  }

  .el-card {
    cursor: pointer;
  }
}
</style>
